import { selectQuestion } from '.';
import { INITIAL_STATE } from '../InitialState';

describe('selectQuestion', () => {
  it('should return the question', () => {
    const question = { label: 'What is your name?' };
    const state = {
      formData: {
        ...INITIAL_STATE,
        planDesign: {
          ...INITIAL_STATE.planDesign,
          questions: {
            test: {
              ...question,
            },
          },
        },
      },
    };
    expect(selectQuestion(state, 'test')).toEqual(question);
  });
});
